import Blank from "@/layouts/blank.vue";
import CodecoRawEventList from "@/pages/admin/codeco-raw-event/CodecoRawEventList.vue";

const codecoRawEventRoutes = [
  {
    path: "codeco-raw-event",
    name: "app-admin-codeco-raw-event",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/codeco-raw-event/list",
      },
      {
        path: "list",
        name: "app-admin-codeco-raw-event-list",
        component: CodecoRawEventList,
      },
    ],
  },
];

export default codecoRawEventRoutes;
